import type { SetState } from '../store';
import { clearLoginGeoPill } from '@/logic/geolocation/login-geo-pill-state';
import { clearInProgressGame } from '@/utils/in-progress-game/in-progress-game';

export enum EmbeddedGameStatus {
    CLOSED = 'closed',
    LOADING = 'loading',
    READY = 'ready',
    DETACHING = 'detaching'
}

export type EmbeddedGameSliceProps = {
    embeddedGame: {
        isOpen: boolean;
        launcherUrl: string | null;
        status: EmbeddedGameStatus;
        transferId: string | null;
        iframeRef: HTMLIFrameElement | null;
        webWrapperReady: boolean;
        open: (launcherUrl: string) => void;
        close: () => void;
        setReady: () => void;
        beginDetach: (transferId: string) => void;
        setIframeRef: (iframe: HTMLIFrameElement | null) => void;
        setWebWrapperReady: (ready: boolean) => void;
    };
};

export const embeddedGameSlice = ({ set }: SetState<EmbeddedGameSliceProps>): EmbeddedGameSliceProps => ({
    embeddedGame: {
        isOpen: false,
        launcherUrl: null,
        status: EmbeddedGameStatus.CLOSED,
        transferId: null,
        iframeRef: null,
        webWrapperReady: false,

        open: (launcherUrl: string) => {
            clearLoginGeoPill();
            set((state) => ({
                embeddedGame: {
                    ...state.embeddedGame,
                    isOpen: true,
                    launcherUrl,
                    status: 'loading',
                    transferId: null
                }
            }));
        },

        close: () => {
            clearInProgressGame();
            set((state) => ({
                embeddedGame: {
                    ...state.embeddedGame,
                    isOpen: false,
                    launcherUrl: null,
                    status: 'closed',
                    transferId: null,
                    iframeRef: null
                }
            }));
        },

        setReady: () => {
            set((state) => ({
                embeddedGame: {
                    ...state.embeddedGame,
                    status: 'ready'
                }
            }));
        },

        beginDetach: (transferId: string) => {
            set((state) => ({
                embeddedGame: {
                    ...state.embeddedGame,
                    status: 'detaching',
                    transferId
                }
            }));
        },

        setIframeRef: (iframe: HTMLIFrameElement | null) => {
            set((state) => ({
                embeddedGame: {
                    ...state.embeddedGame,
                    iframeRef: iframe
                }
            }));
        },

        setWebWrapperReady: (ready: boolean) => {
            set((state) => ({
                embeddedGame: {
                    ...state.embeddedGame,
                    webWrapperReady: ready
                }
            }));
        }
    }
});
